import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  staffData: null,
};

const staffSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    setStaffInfo: (state, action) => {
      state.staffData = action.payload;
    },
    clearStaffData: (state) => {
      state.staffData = null;
    },
  },
});

export const { setStaffInfo, clearStaffData } = staffSlice.actions;
export default staffSlice.reducer;
